module.exports = __webpack_public_path__ + "static/media/20210109_230526_413_IMG_1870.2c6cc187.jpg";